import { useEffect } from "react";

import { ensureLegacyGrapeshot } from "./grapeshotLegacy";

export default function AnalyticsGrapeshot() {
  useEffect(() => {
    // Fire-and-forget analytics bootstrap: ensureLegacyGrapeshot() rejects on a
    // non-2xx/network failure, so swallow it here to avoid an unhandled
    // rejection in the console (the promise is memoised for later readers).
    void ensureLegacyGrapeshot().catch(() => undefined);
  }, []);
  return null;
}
